import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgSmilieHappy } from './svg/smilie-happy.svg.js';

/**
 * @deprecated - use RatingHappy.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const SmilieHappy = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgSmilieHappy, { viewBox: "0 0 24 24", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "SmilieHappy" }));
};

export { SmilieHappy as default };
//# sourceMappingURL=SmilieHappy.js.map
